import { FC, memo } from "react";
import { WithStyle } from "utils/WithStyle";
import { SidebarWrapper } from "./Sidebar.styled";
import { SidebarProps, SidebarStaticProps } from "./types";
import Item from "./Item";

const Component: FC<SidebarProps> = memo((props) => {
    return <SidebarWrapper {...props}>{props.children}</SidebarWrapper>;
});

export const Sidebar: FC<SidebarProps> & WithStyle & SidebarStaticProps =
    Object.assign(Component, {
        Style: SidebarWrapper,
        Item,
    });
